import isString from 'lodash/isString';
import escapeRegExp from 'lodash/escapeRegExp';

const regExpWithParenthesis = '[(]\\d+([\\s]+\\d+)*[)]+';
const getRegExpWithCode = (code) => RegExp(`(${escapeRegExp(code)})${regExpWithParenthesis}`);

/**
 * Generate a new code, not included in current formNodes
 * @param {Object} node
 * @param {Array} existingCodesStartingWith
 * @return {String}
 */
export const createNewCode = (node, existingCodesStartingWith) => {
    const duplicatedNumbers = existingCodesStartingWith
        .filter((code) => getRegExpWithCode(node.code).test(code))
        .map((code) => parseInt(RegExp(regExpWithParenthesis).exec(code)[0].replace('(', '').replace(')', ''), 10));

    const max = Math.max(0, ...duplicatedNumbers);

    return `${node.code}(${max + 1})`;
};

/**
 * Get an array of existing codes in current formNodes
 * @param {Object} node
 * @param {Object} currentFormNodes
 * @return {Array}
 */
export const getExistingNodesWithCode = (node, currentFormNodes) =>
    Object.keys(currentFormNodes)
        .filter((currentNodeId) => {
            const currentNode = currentFormNodes[currentNodeId];

            return (
                isString(currentNode.code) &&
                (currentNode.code === node.code || getRegExpWithCode(node.code).test(currentNode.code)) &&
                currentNode.formId === node.formId
            );
        })
        .map((currentNodeId) => currentFormNodes[currentNodeId].code);

/**
 * Check the node for duplicated codes in current formNodes
 * @param {Object} currentFormNodes
 * @return {Object} A node which code doesn't collide with current nodes
 */
export const avoidCodeCollisions = (currentFormNodes) => (node) => {
    const existingNodesWithCode =
        !node.code || !isString(node.code) ? [] : getExistingNodesWithCode(node, currentFormNodes);

    const hasExistingNodesWithCode = existingNodesWithCode.length > 0;

    return hasExistingNodesWithCode
        ? {
              ...node,
              code: createNewCode(node, existingNodesWithCode),
          }
        : node;
};
